import {LoginBlock} from "../../components/auth/LoginBlock/LoginBlock";
import "./Login.scss";

export const Login = () => {
    return (
        <div className={"login-page"}>
            <LoginBlock/>
        </div>
    );
};